import React from 'react';

function UserLogin() {
  return (
    <div>
      <h1>User Login</h1>
      {/* Contenido de la página */}
    </div>
  );
}

export default UserLogin;
